import React, { Fragment, useState, useEffect } from "react";
import CustomLoader from "../../customLoader/CustomLoader";
import GetAdminService from "../../../services/admin/GetAdminService";
import AppHeader from "../../../Layout/AppHeader";
import AppSidebar from "../../../Layout/AppSidebar";
import CustomPagination from "../../pagination/Pagination";
import moment from "moment";
import "../AdminPages.css";

const ExportResultRecruiter = () => {
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [pageData, setPageData] = useState();

  useEffect(() => {
    exportRecruiterData();
  }, [page]);

  const exportRecruiterData = () => {
    setLoading(true);
    let obj = {
      page: page,
    };
    GetAdminService.getExportData(obj)
      .then((data) => {
        setPageData(data.data);
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  return (
    <Fragment>
      <AppHeader />
      <div className="app-main">
        <AppSidebar />
        <div className="app-main__outer">
          <div className="csv-import-container">
            <div className="admin-students-page-header">
              <h2>Export Result Report</h2>
            </div>

            {loading ? (
              <div className="admin-page-section">
                <CustomLoader />
              </div>
            ) : (
              pageData && (
                <div className="admin-page-table-wrap">
                  <table className="admin-page-table">
                    {pageData?.result?.length > 0 && (
                      <thead>
                        <tr>
                          <th>Recruiter Email</th>
                          <th>College Name</th>
                          <th>Query Type</th>
                          <th>Export Time</th>
                          <th>Result Count</th>
                        </tr>
                      </thead>
                    )}
                    <tbody>
                      {pageData?.result?.map((item, index) => (
                        <tr key={index}>
                          <td>{item?.recruiter_email}</td>
                          <td>{item?.college_name}</td>
                          <td>{item?.query_type}</td>
                          <td>
                            {moment(item.export_time).format(
                              "ddd MMM Do YYYY, hh:mm:ss a"
                            )}
                          </td>
                          <td>{item?.result_count}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )
            )}

            {pageData && pageData?.page_list?.length > 1 && (
              <div className="admin-page-pagination">
                <CustomPagination
                  count={pageData && pageData}
                  pageValue={page}
                  setPage={setPage}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default ExportResultRecruiter;
